var map = {
	"./combate-incendios.jpg": "5bbda",
	"./gracias.png": "47e7",
	"./pediatricos.png": "b60d",
	"./primer-respondiente.jpg": "37ae",
	"./tum.jpeg": "f05b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ed2";